const marketFlights = {
    toronto: [
        {
            airline: 'Air Canada',
            arrivalWithCode: 'Montreal (YUL)',
            currency: 'CAD',
            dateRange: 'May 11–18',
            departureDate: '2025-05-11',
            departureWithCode: 'Toronto (YYZ)',
            destination: 'Montreal',
            fareClass: 'Business Lowest',
            pointsValue: 19,
            price: 917.13,
            returnDate: '2025-05-18',
            tripType: 'Roundtrip',
        },
        {
            airline: 'Delta',
            arrivalWithCode: 'New York (JFK)',
            currency: 'CAD',
            dateRange: 'May 11–18',
            departureDate: '2025-05-11',
            departureWithCode: 'Toronto (YYZ)',
            destination: 'New York',
            fareClass: 'Business Lowest',
            pointsValue: 10,
            price: 542.22,
            returnDate: '2025-05-18',
            tripType: 'Roundtrip',
        },
        {
            airline: 'Air Canada',
            arrivalWithCode: 'London (LHR)',
            currency: 'CAD',
            dateRange: 'May 11–18',
            departureDate: '2025-05-11',
            departureWithCode: 'Toronto (YYZ)',
            destination: 'London',
            fareClass: 'Business Lowest',
            pointsValue: 176,
            price: 9116.6,
            returnDate: '2025-05-18',
            tripType: 'Roundtrip',
        },
    ],
    vancouver: [
        {
            airline: 'Air Canada',
            arrivalWithCode: 'Toronto (YYZ)',
            currency: 'CAD',
            dateRange: 'May 11–18',
            departureDate: '2025-05-11',
            departureWithCode: 'Vancouver (YVR)',
            destination: 'Toronto',
            fareClass: 'Business Lowest',
            pointsValue: 33,
            price: 1433.76,
            returnDate: '2025-05-18',
            tripType: 'Roundtrip',
        },
        {
            airline: 'United Airlines',
            arrivalWithCode: 'San Francisco (SFO)',
            currency: 'CAD',
            dateRange: 'May 11–18',
            departureDate: '2025-05-11',
            departureWithCode: 'Vancouver (YVR)',
            destination: 'San Francisco',
            fareClass: 'First Or Business Fully Ref',
            pointsValue: 1,
            price: 1072.02,
            returnDate: '2025-05-18',
            tripType: 'Roundtrip',
        },
        {
            airline: 'American Airlines',
            arrivalWithCode: 'Tokyo (HND)',
            currency: 'CAD',
            dateRange: 'May 11–18',
            departureDate: '2025-05-11',
            departureWithCode: 'Vancouver (YVR)',
            destination: 'Tokyo',
            fareClass: 'Flagship Business',
            pointsValue: 1,
            price: 10_544.27,
            returnDate: '2025-05-18',
            tripType: 'Roundtrip',
        },
    ],
};

import {
    ref,
    computed,
    inject,
} from 'vue';

export default {
    name: 'AtmFeatured',
    props: {
        campaign: {
            default: '',
            type: String,
        },
        market: {
            default: '',
            required: true,
            type: String,
            validator: (value) => ['vancouver', 'toronto'].includes(value),
        },
    },
    setup (props) {

        // Format price with CAD currency
        const formatPrice = (price, digits = 2) => {
            return new Intl.NumberFormat('en-CA', {
                currency: 'CAD',
                minimumFractionDigits: digits,
                style: 'currency',
            }).format(price);
        };



        const capitalizeFirstLetter = (string) => {
            return string.charAt(0).toUpperCase() + string.slice(1)
        }


        const languageData = ref(inject('$languageData').value.home)

        const destination = computed(() => capitalizeFirstLetter(props.market))

        const navigateToSearch = (flight) => {
            const searchParameters = new URLSearchParams({
                adults: '1',
                arrival: flight.arrivalWithCode,
                arrivalDate: flight.returnDate,
                children: '0',
                departure: flight.departureWithCode,
                departureDate: flight.departureDate,
                searchType: 'search',
                stops: 0,
            });

            window.location.href = `/search?${searchParameters.toString()}`;
        };

        const calculatePrice = (pointsValue) => {
            switch (props.campaign) {
                case 'campaign2': {
                    return pointsValue * 2;
                }
                case 'campaign3': {
                    return pointsValue;
                }
                default: {
                    return pointsValue;
                }
            }
        };

        const flights = computed(() => {
            return marketFlights[props.market]?.map(flight => ({
                ...flight,
                pointsValue: calculatePrice(flight.pointsValue),
            })) || [];
        });


        return {
            destination,
            flights,
            formatPrice,
            languageData,
            navigateToSearch,
        };
    },
};